import React from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { name: 'Dashboard', path: '/dashboard' },
  { name: 'Bot Control', path: '/dashboard/bot-control' },
  { name: 'Wallet Stats', path: '/dashboard/wallet' },
  { name: 'Live Performance', path: '/dashboard/performance' },
  { name: 'Bot Logs', path: '/dashboard/logs' },
  { name: 'Settings', path: '/dashboard/settings' },
  { name: 'Support', path: '/dashboard/support' }
];

export default function Sidebar() {
  return (
    <aside className="w-64 min-h-screen bg-[#062925] p-6 shadow-md">
      <div className="text-2xl font-bold mb-10 tracking-wide text-[#CE9242]">
        VORTREX
      </div>
      <nav className="space-y-4">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `block px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-[#0B3A32] text-teal-400'
                  : 'text-[#CE9242] hover:bg-[#0B3A32] hover:text-teal-300'
              }`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
